<template>
  <div>
    <div class="img-container" v-if="contactus">
      <img
        alt="pic"
        v-if="contactus && contactus.imgUrl"
        :src="baseUrl + contactus.imgUrl"
      />
      <div
        v-if="contactus"
        class="contact-info-container"
        v-html="contactus.articleTxt"
      ></div>
    </div>
    <div
      v-if="loaded && !contactus"
      class="no-data-container j-coming-soon j-content"
    >
      {{ $t('common.coming_soon') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { getArticleListByTypes } from '@/api/apis';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'ContactUs',
  created() {
    this.loadData();
  },
  data() {
    return {
      baseUrl,
      contactus: null,
      loaded: false
    };
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      const res = await getArticleListByTypes({
        types: 5
      });

      if (res.success) {
        const data = res.result || [];

        this.contactus = data[0] || null;
      }

      this.loaded = true;
    }
  }
});
</script>

<style lang="scss" scoped>
.no-data-container {
  min-height: calc(100vh - 180px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-container {
  min-height: calc(100vh - 180px);
  position: relative;
  img {
    height: 100%;
    width: 100%;
    display: inline-block;
  }

  display: flex;
  justify-content: center;

  .contact-info-container {
    position: absolute;
    top: 80px;
    /* min-height: 280px; */
    opacity: 0.8;
    padding: 40px 240px;
    margin: 0 40px;
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      #ffffff 21%,
      #ffffff 79%,
      rgba(255, 255, 255, 0) 100%
    );
  }
}
</style>
